import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(content)/privacy-policy/components/privpol-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/wrappers/navWrapper.tsx");
